import React from 'react';
import point from './img/placeholder.png'
import telegram from './img/telegram.png'
import whatsapp from './img/whatsapp.png'
import partner2 from './img/Trophy_site.jpg'
import { saveAs } from 'file-saver';
import Email from "./Email";
import './Footer.css';

const translate = {
  prase1:{ 
      eng: "CONTACT US", 
      fra: "NOS CONTACTS" 
  },
  prase3:{ 
      eng: "TERMS & CONDITIONS",
      fra: "TERMES ET CONDITIONS"         
  },
  prase4:{ 
      eng: "OUR PARTNER",
      fra: "NOTRE PARTENAIRE"        
  }
}

const Footer = ({language}) => {
  const handleDownload = () => {
    const pdfPath = process.env.PUBLIC_URL + '/static/pdfs/Terms-of-Service.pdf';
    saveAs(pdfPath, 'Terms-of-Service.pdf');
  };
  return (
      <div className="footer">
        <div className="container">
          <div className="column">
            <h3><span className='pointed-foo'>{translate.prase1[language]}</span></h3>
            <p>
              <img className='contactIcons' src={point} alt="point" /> <a href="https://maps.app.goo.gl/a5h8ci1WPnjyfFfq9">15244 Douala</a>
            </p>
            <Email />
            <p>
              <img className='contactIcons' src={telegram} alt="telegram" /> <img src={whatsapp} alt="telegram" /> +237 698484898
            </p>
          </div>
          <div className="column">
            <h3><span className='pointed-foo'>{translate.prase3[language]}</span></h3>
            <p>
              <button onClick={handleDownload} className='footer-btn'>
                Terms of Service.pdf
              </button>
            </p>
          </div>
          <div className="column">
            <h3><span className='pointed-foo'>{translate.prase4[language]}</span></h3>
            <p><a href="https://dvb4all.com/" className='partner'>Dvb4all.com</a></p>
            <p><img className='partner-img' src={partner2} alt="partners" /></p>
          </div> 
        </div>
      </div>
    );
  };

export default Footer;